import React, { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/pro-regular-svg-icons/faBell";

export const Bell: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faBell} {...props} />
);
